import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ルート遷移時にページ先頭へスクロールする。
 *
 * React Router は既定でスクロール位置を維持するため、長いページ（FAQ・利用規約・
 * プライバシーポリシー等）へ遷移しても直前の位置のままになってしまう。これを解消し、
 * 遷移のたびに必ずページ先頭から表示されるようにする。
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
